"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetMemberAgreementsResponseSchema = exports.UpdateAgreementsResponseSchema = exports.UpdateAgreementsInputSchema = exports.MemberAgreementSchema = exports.AgreementsKeySchema = exports.AgreementsDataSchema = exports.MemberResultCode = void 0;
var zod_1 = require("zod");
var booleanNullable = function () { return zod_1.z.boolean().nullable(); };
exports.MemberResultCode = {
    success: 'SUCCESS',
    failed: 'FAILED',
};
exports.AgreementsDataSchema = zod_1.z.object({
    isTermOfServiceAgreed: booleanNullable(),
    isPrivacyAgreed: booleanNullable(),
    isLocationAgreed: booleanNullable(),
    isMarketingLeverageAgreed: booleanNullable(),
    isMarketingPushReceived: booleanNullable(),
    isPushReceived: booleanNullable(),
    isConciergeReceived: booleanNullable(),
    memberNo: zod_1.z.number(),
    isInactivityAgreed: booleanNullable(),
    isEmailReceived: booleanNullable(),
    isSmsReceived: booleanNullable(),
    isCertificationAgreed: booleanNullable(),
    isAdultCertificationAgreed: booleanNullable(),
    isPrepaymentCertificationAgreed: booleanNullable(),
    isPrepaymentAgreed: booleanNullable(),
    isPromotion210415Agreed: booleanNullable(),
    isPrePromo211109Agreed: booleanNullable(),
    isPrePromo211109OptionAgreed: booleanNullable(),
    isPromo211109Agreed: booleanNullable(),
    isPromo211115Agreed: booleanNullable(),
    isPromo220407Agreed: booleanNullable(),
    isPromo220524Agreed: booleanNullable(),
    isPromo220602Agreed: booleanNullable(),
    isPromo220607Agreed: booleanNullable(),
    isPromo220907Agreed: booleanNullable(),
    isPromo220914Agreed: booleanNullable(),
    isPromo230530Agreed: booleanNullable(),
    isPromo230825Agreed: booleanNullable(),
    isPromo230927Agreed: booleanNullable(),
    isPromo231027Agreed: booleanNullable(),
    isPromo240207Agreed: booleanNullable(),
    isPromo240227Agreed: booleanNullable(),
    isPromo240603Agreed: booleanNullable(),
    isPromo240827Agreed: booleanNullable().optional(),
    isPromo250228Agreed: booleanNullable().optional(),
    isPromo250528Agreed: booleanNullable().optional(),
    isRestaurantAgreed: booleanNullable(),
    isNolAgreed: booleanNullable(),
    isNolPointAgreed: booleanNullable(),
    isYanoljaFnbAgreed: booleanNullable().optional(),
    isInterparkTripleAgreed: booleanNullable().optional(),
});
exports.AgreementsKeySchema = exports.AgreementsDataSchema.omit({ memberNo: true }).keyof();
exports.MemberAgreementSchema = zod_1.z.object({
    result: zod_1.z.nativeEnum(exports.MemberResultCode),
    data: exports.AgreementsDataSchema,
});
exports.UpdateAgreementsInputSchema = exports.AgreementsDataSchema.omit({ memberNo: true })
    .partial()
    .refine(function (data) { return Object.keys(data).length > 0; }, '저장해야할 동의정보를 입력해주세요.');
exports.UpdateAgreementsResponseSchema = exports.AgreementsDataSchema;
exports.GetMemberAgreementsResponseSchema = exports.AgreementsDataSchema;
